"use strict";

function toggleReactionElements(reactionElement) {
  const isActive = reactionElement.classList.contains('active');
  const iconWithOwnReaction = reactionElement.querySelector('.js_ownHasOwn');
  const iconWithoutOwnReaction = reactionElement.querySelector('.js_withoutOwn');
  iconWithOwnReaction?.classList.toggle('hide', !isActive);
  iconWithoutOwnReaction?.classList.toggle('hide', isActive);
}

// eslint-disable-next-line no-unused-vars
async function addReaction(commentId, reactionType) {
  const userToken = window.getUserToken();
  if (!userToken) {
    window.openModalWelcome('comments');
    return;
  }
  const likeElement = document.querySelector(`.js_like-${commentId}`);
  const dislikeElement = document.querySelector(`.js_dislike-${commentId}`);
  if (!likeElement || !dislikeElement) return;
  const likeCountElement = likeElement.querySelector('.js_commentsLikeCount');
  const dislikeCountElement = dislikeElement.querySelector('.js_commentsDislikeCount');
  if (!likeCountElement || !dislikeCountElement) return;
  let likesCount = Number(likeCountElement.innerText);
  let dislikesCount = Number(dislikeCountElement.innerText);
  const containsReaction = likeElement.classList.contains('active') || dislikeElement.classList.contains('active');
  function updateLikes(clickedCount, otherCount, clickedLike, otherLike) {
    if (containsReaction) {
      if (clickedLike.classList.contains('active')) {
        clickedCount--;
        clickedLike.classList.remove('active');
      } else {
        clickedCount++;
        otherCount--;
        clickedLike.classList.add('active');
        otherLike.classList.remove('active');
      }
    } else {
      clickedCount++;
      clickedLike.classList.add('active');
    }
    return [clickedCount, otherCount];
  }
  const apiUrl = `${window.baseApiUrl}/comments/${commentId}/${reactionType}`;
  const headers = window.baseHeadersJsonApi;
  headers.Authorization = `Bearer ${userToken}`;
  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        data: {
          attributes: {
            likes: likesCount,
            dislikes: dislikesCount,
            undo: containsReaction
          }
        }
      })
    });
    if (response.ok) {
      if (reactionType === 'like') {
        [likesCount, dislikesCount] = updateLikes(likesCount, dislikesCount, likeElement, dislikeElement);
      } else {
        [dislikesCount, likesCount] = updateLikes(dislikesCount, likesCount, dislikeElement, likeElement);
      }
      toggleReactionElements(likeElement);
      toggleReactionElements(dislikeElement);
      likeCountElement.innerText = likesCount === 0 ? '' : likesCount;
      dislikeCountElement.innerText = dislikesCount === 0 ? '' : dislikesCount;
    } else {
      window.showSnackbar('Reagiranje ti nije dozvoljeno', 'warning');
    }
  } catch (error) {
    window.showSnackbar('Došlo je do greške pri postavljanju komentara', 'error');
  }
}